import React from "react";
import { AlertTriangle, StopCircle } from "lucide-react";
import { useSuiteContext } from "./SuiteContextProvider";

/**
 * ImpersonationBanner - fascia persistente durante la simulazione.
 *
 * Deve essere sempre visibile in cima all'app (montarlo nel Layout globale).
 * L'utente ROOT/admin vede chiaramente che sta operando come un altro utente
 * e puo' terminare la simulazione con un click.
 */
export function ImpersonationBanner() {
  const { context, endImpersonation } = useSuiteContext();
  if (!context?.is_impersonating) return null;
  const target = context.effective_user;
  return (
    <div
      className="flex items-center justify-between gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-white"
      role="alert"
      data-testid="suite-impersonation-banner"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle size={16} className="text-white" />
        <span>
          <strong>MODALITÀ SIMULAZIONE</strong> · stai operando come{" "}
          <span data-testid="impersonation-target">
            {target?.display_name}
          </span>
          {target?.role && (
            <span className="ml-1 text-amber-100">({target.role})</span>
          )}
        </span>
      </div>
      <button
        type="button"
        onClick={() => endImpersonation()}
        className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold text-white hover:bg-white/30"
        data-testid="impersonation-end-button"
      >
        <StopCircle size={14} /> Termina simulazione
      </button>
    </div>
  );
}
